import * as React from 'react';
import globalI18nInstance from '@insolus/i18n';
export default React.createContext(globalI18nInstance);